import { DebouncedTextField } from '@tunasong/ui-lib'
import type { FC } from 'react'
import styles from './stage-setup-editor.module.css'

export interface NameStepProps {
  name?: string
  onSave(name: string): void
}

/**
 * "Your name on riders": asked only when the profile has no display name, so the venue sees a person rather than an
 * email fragment. The editor decides once per session whether to show it, so the field never vanishes mid-typing.
 */
export const NameStep: FC<NameStepProps> = props => {
  const { name, onSave } = props
  return (
    <DebouncedTextField
      className={styles.field}
      label="Your name on riders"
      helperText="This is how the venue's crew will see you."
      value={name?.trim() ? name : ''}
      onDebouncedChange={value => onSave(value.trim())}
      autoComplete="name"
    />
  )
}

export default NameStep
